/* src/app/feature-modules/forms/forms.component.css */
tr > img {
  width: 40px;
}
.search-results {
  height: 100rem;
  overflow: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgb(158, 158, 158);
}
::-webkit-scrollbar-thumb:hover {
  background: rgb(158, 158, 158);
}
/*# sourceMappingURL=forms.component.css.map */
